import React from 'react';
import Box from '@mui/material/Box';
import DNSItem from './DNSItem';
import SMTPItem from './SMTPItem';

const ElementsSection = () => {
  return (
    <Box>
      <Box>
        <DNSItem />
        <SMTPItem />
      </Box>
    </Box>
  );
};

export default ElementsSection;
